import styled from 'styled-components';
import { Icon } from 'antd';

export const IconStyled = styled(Icon)`
  font-size: 17px;
  color: black;
  margin-left: 10px;
  position: relative;
  top: 1px;

  &:hover{
    color: #0e81ea!important;
  }
`;